import React, { useState } from 'react';

const CTASection = ({ selectedService, services }) => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    service: ''
  });
  const [showSuccess, setShowSuccess] = useState(false);

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Simulate form submission
    setShowSuccess(true);
    setFormData({ name: '', phone: '', service: '' });
    setTimeout(() => {
      setShowSuccess(false);
    }, 4000);
  };

  React.useEffect(() => {
    if (selectedService && services[selectedService]) {
      setFormData(prev => ({
        ...prev,
        service: services[selectedService].label
      }));
    }
  }, [selectedService, services]);

  return (
    <section
      id="cta-section"
      className="bg-gradient-to-r from-primary-600 to-primary-700 text-white p-8 md:p-12 rounded-2xl shadow-primary-xl mt-12 text-center"
    >
      <h3 className="text-3xl font-bold mb-3">Bạn thấy sự thay đổi rồi chứ?</h3>
      <p className="text-lg text-primary-100 max-w-2xl mx-auto mb-6">
        {services[selectedService]?.note || 'Đây là mô phỏng bằng AI – kết quả thực tế sẽ còn tuyệt vời hơn sau liệu trình chính hãng tại Vanilla Clinic!'}
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-3xl mx-auto bg-white p-8 rounded-xl shadow-lg">
        {/* Form đăng ký */}
        <form onSubmit={handleSubmit} className="text-left">
          <h4 className="text-xl font-bold text-gray-900 mb-4">Đăng ký tư vấn miễn phí</h4>

          <div className="mb-4">
            <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">
              Họ và tên *
            </label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              className="w-full p-3 border border-gray-300 rounded-lg text-gray-900 focus:ring-2 focus:ring-primary-400 focus:border-transparent"
              required
            />
          </div>

          <div className="mb-4">
            <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1">
              Số điện thoại *
            </label>
            <input
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleInputChange}
              className="w-full p-3 border border-gray-300 rounded-lg text-gray-900 focus:ring-2 focus:ring-primary-400 focus:border-transparent"
              required
            />
          </div>

          <div className="mb-4">
            <label htmlFor="service" className="block text-sm font-medium text-gray-700 mb-1">
              Dịch vụ quan tâm
            </label>
            <input
              type="text"
              id="service"
              name="service"
              value={formData.service}
              onChange={handleInputChange}
              className="w-full p-3 border border-gray-300 rounded-lg text-gray-900 bg-gray-100"
              readOnly
            />
          </div>

          <button
            type="submit"
            className="w-full py-3 px-6 bg-primary-600 text-white text-lg font-semibold rounded-lg shadow-primary hover:bg-primary-700 transition-all hover:shadow-primary-lg"
          >
            Gửi đăng ký
          </button>

          {showSuccess && (
            <p className="text-primary-600 font-medium text-center mt-4">
              Cảm ơn bạn! Chuyên viên Vanilla sẽ liên hệ bạn sớm.
            </p>
          )}
        </form>

        {/* Lựa chọn khác */}
        <div className="flex flex-col items-center justify-center text-left text-gray-900 border-t md:border-t-0 md:border-l border-gray-200 pt-6 md:pt-0 md:pl-6">
          <h4 className="text-xl font-bold text-gray-900 mb-4">...hoặc trò chuyện ngay!</h4>
          <p className="text-gray-600 mb-4 text-center">
            Nhận tư vấn 1:1 nhanh chóng qua Zalo hoặc Messenger.
          </p>

          <button
            type="button"
            onClick={() => window.open('https://m.me/VienThamMyVanilla', '_blank')}
            className="w-full py-3 px-6 bg-blue-500 text-white text-lg font-semibold rounded-lg shadow-md hover:bg-blue-600 transition-all flex items-center justify-center gap-2 mb-3"
          >
            <i className="ph-messenger-logo-fill text-xl"></i>
            <span>Chat qua Messenger</span>
          </button>

          <button
            type="button"
            onClick={() => window.open('https://zalo.me/0899739739', '_blank')}
            className="w-full py-3 px-6 bg-blue-400 text-white text-lg font-semibold rounded-lg shadow-md hover:bg-blue-500 transition-all flex items-center justify-center gap-2"
          >
            <i className="ph-chats-fill text-xl"></i>
            <span>Chat qua Zalo</span>
          </button>

        </div>
      </div>
    </section>
  );
};

export default CTASection;